import React from "react";
import {
  ActionsButton,
  ActionsColumn,
  ActionsColumnDivider,
  ActionsColumnsContainer,
  ActionsContainer,
  TranslateContainer,
} from "./styles";
import { useAnnouncementsStore } from "../../../../../../stores/use-announcements-store";
import { movePermission } from "./move";
import Trash from "../../../../../cards-v2/components/actions/icons/Trash";
import ArrowLeft from "../../../../../cards-v2/components/actions/icons/ArrowLeft";
import ArrowRight from "../../../../../cards-v2/components/actions/icons/ArrowRight";
import Link from "../../../../../cards-v2/components/actions/icons/Link";
import Duplicate from "../../../../../cards-v2/components/actions/icons/Duplicate";
import { MACRO_EDIT_EVENTS } from "@Shared/events/macro-edit-events";
import { DESIGN_STYLES } from "../../../../../../optics/components/drawers/settings/features/announcements/defaults";
import Emoji from "../../../../../cards-v2/components/actions/icons/Emoji";
import Image from "../../../../../cards-v2/components/actions/icons/Image";

function Actions() {
  const {
    hoveredAnnouncement,
    setSelectedAnnouncement,
    updateData,
    data,
    config,
    removeAnnouncement,
    moveAnnouncement,
  } = useAnnouncementsStore((state) => ({
    hoveredAnnouncement: state.hoveredAnnouncement,
    setSelectedAnnouncement: state.setSelectedAnnouncement,
    updateData: state.updateData,
    data: state.data,
    config: state.config,
    removeAnnouncement: state.removeAnnouncement,
    moveAnnouncement: state.moveAnnouncement,
  }));

  const announcement = data.find((item) => item.id === hoveredAnnouncement);
  const { canMoveLeft, canMoveRight } = movePermission({
    data,
    id: announcement.id,
  });

  const handleActionClick = (event) => {
    setSelectedAnnouncement(hoveredAnnouncement);
    window.AP.events.emit(event);
  };

  return (
    <ActionsContainer onClick={(e) => e.stopPropagation()}>
      <ActionsColumnsContainer>
        <ActionsColumn>
          {config.designStyle === DESIGN_STYLES.NOTIFICATION && (
            <ActionsButton
              onClick={() =>
                handleActionClick(MACRO_EDIT_EVENTS.OPEN_ICON_PICKER)
              }
            >
              <Emoji />
            </ActionsButton>
          )}
          {config.designStyle === DESIGN_STYLES.BACKGROUND && (
            <ActionsButton
              onClick={() =>
                handleActionClick(MACRO_EDIT_EVENTS.OPEN_IMAGE_PICKER)
              }
            >
              <Image />
            </ActionsButton>
          )}
          <ActionsButton
            onClick={() =>
              handleActionClick(MACRO_EDIT_EVENTS.OPEN_LINK_PICKER)
            }
          >
            <Link />
          </ActionsButton>
          <ActionsButton
            onClick={() => {
              updateData([
                ...data,
                {
                  ...announcement,
                  id: crypto.randomUUID(),
                },
              ]);
            }}
          >
            <Duplicate />
          </ActionsButton>
          <ActionsButton
            onClick={() => removeAnnouncement(hoveredAnnouncement)}
          >
            <Trash />
          </ActionsButton>
        </ActionsColumn>

        <ActionsColumnDivider />

        <ActionsColumn>
          <ActionsButton
            isClickable={canMoveLeft}
            onClick={() => moveAnnouncement(hoveredAnnouncement, "left")}
          >
            <TranslateContainer isList={config.view === "list"}>
              <ArrowLeft />
            </TranslateContainer>
          </ActionsButton>
          <ActionsButton
            isClickable={canMoveRight}
            onClick={() => moveAnnouncement(hoveredAnnouncement, "right")}
          >
            <TranslateContainer isList={config.view === "list"}>
              <ArrowRight />
            </TranslateContainer>
          </ActionsButton>
        </ActionsColumn>
      </ActionsColumnsContainer>
    </ActionsContainer>
  );
}

export default Actions;
